// extracted by mini-css-extract-plugin
export default {"hed":"Qm","blend":"Rm","resultsBox":"Sm","left":"Tm","right":"Um","center":"Vm","base":"Wm","milk":"Xm","text":"Ym","hyroxresult":"Zm","margin":"an"};
    if(module.hot) {
      // 1715188229036
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  